import { Component } from '@angular/core';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.html',
  styleUrl: './maintenance.scss'
})
export class MaintenanceComponent {}
